<style scoped lang="scss">
  // @import "../user";
  .order{
    border-bottom: 1px solid #E4E6EA;
    border-top: 1px solid #E4E6EA;
    .top{
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #E4E6EA;
      padding:10px 15px;
      dl{
        display: flex;
        dd{
          margin-right: 40px;
        }
      }
      .status{
        color: #014492;
        font-weight: bold;
      }
    }
    .products{
      li{
        display: flex;
        align-items: center;
        padding:15px;
        font-size: 12px;
        border-bottom: 1px solid #E4E6EA;
        &:last-child{
          border-bottom: 0;
        }
        .img-box{
          img{
            max-width: 60px;
            margin-right: 15px;
          }
        }
        .info{
          // flex:1;
          // border-right: 2px solid #E4E6EA;
          padding: 0 8px;
           &:last-child{
            border:0;
          }
        }
        .title{
          font-size: 12px;
        }
        .cursor {
          cursor:pointer;
        }
        .cursor:hover {
          color: #014492;
        }
      }
      dl{
        display: flex;
        flex-wrap: wrap;
        dd{
          width:25%;
          margin-top:8px;
          label{
            color:#999;
          }
        }
      }
      &.multi{
        dl{
          dd{
            width:33.33%;
          }
        }
      }
    }
  }
  .badge {
    display: inline-block;
    width: 25px;
    height: 20px;
    padding: 3px 7px;
    font-size: 11px;
    font-weight: bold;
    color: #fff;
    line-height: 1;
    vertical-align: middle;
    white-space: nowrap;
    text-align: center;
    background-color: #777;
    border-radius: 10px;
}
.bg-orange-light {
    background-color: #014492;
    margin-right: 5px;
}
  .el-input-number{
    width:120px;
  }
  @media screen and (max-width: 640px) and (min-width: 600px) {
    .order .products li {
      width: 100% !important;
      overflow: auto;
      display: block !important;

    }
    .order .products li .li_div {
      display: -webkit-box;
    }
    .order .products .img-box {
      width: 150px;
      margin-right: 5px;
      float: left;
    }
    .chakan1 {
      display: none;
      overflow: auto;
    }
    .chakan {
      overflow: auto;
      padding: 0!important;
      display: block;
    }
    .order .products .img-box img {
      max-width: 100% !important;
      margin-right: 0!important;
    }
    .order .products li .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
    }
    .info_span {
      margin-top: 10px;
      overflow: auto;
      border-top:1px solid #E4E6EA;
      padding-top: 10px;
    }
    .info_span .cursor{
      float: left;
    }
    .info_span1{
      float: right;
    }
    .info_first{
      width: 74%;
    }
    .info_span .cursor {
      width: 40px;
      height: 25px;
      display: block;
      margin-right: 25px;
      text-align: center;
      padding: 2px;
      border: 1px solid #666666;
      border-radius: 3px;
    }
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (min-width: 300px) and (max-width:400px) {
    .order .products li {
      width: 100% !important;
      overflow: auto;
      display: block !important;

    }
    //.order .products li .li_div {
    //  display: -webkit-box;
    //}
    //.order .products .img-box {
    //  width: 100px;
    //  margin-right: 5px;
    //  float: left;
    //}
    .chakan1 {
      display: none;
      overflow: auto;
    }
    .chakan {
      overflow: auto;
      padding: 0!important;
      display: block;
    }
    .order .products .img-box img {
      max-width: 100% !important;
      margin-right: 0!important;
    }
    //.info_first{
    //  width: 71%;
    //}
    .order .products li .info{
      padding: 0!important;
    }
    .order .products li .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
    }
    .info_span {
      margin-top: 10px;
      overflow: auto;
      border-top:1px solid #E4E6EA;
      padding-top: 10px;
    }
    .info_span .cursor{
      float: left;
    }
    .info_span1{
      float: right;
    }
    .info_span .cursor {
      width: 40px;
      height: 25px;
      display: block;
      margin-right: 25px;
      text-align: center;
      padding: 2px;
      border: 1px solid #666666;
      border-radius: 3px;
    }
  }
  @media screen and (max-width: 414px) and (min-width: 413px) {
    .order .products li {
      width: 100% !important;
      overflow: auto;
      display: block !important;

    }
    .order .products li .li_div {
      //display: -webkit-box;
    }
    .info_first{
      //width: 75%;
    }
    .order .products .img-box {
      //width: 100px;
      //float: left;
    }
    .order .products li .info{
      padding: 0!important;
    }
    .chakan1 {
      display: none!important;
      overflow: auto;
    }
    .chakan {
      overflow: auto;
      padding: 0!important;
      display: block!important;
    }
    .order .products .img-box img {
      max-width: 100% !important;
      margin-right: 0!important;
    }
    .order .products li .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
    }
    .info_span {
      margin-top: 10px;
      overflow: auto;
      border-top:1px solid #E4E6EA;
      padding-top: 10px;
    }
    .info_span .cursor{
      float: left;
    }
    .info_span1{
      float: right;
    }
    .info_span .cursor {
      width: 40px;
      height: 25px;
      display: block;
      margin-right: 25px;
      text-align: center;
      padding: 2px;
      border: 1px solid #666666;
      border-radius: 3px;
    }
  }
  .chakan{
    display: none;
  }
  .chakan1{
    display: block;
  }
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title" style="margin-bottom: 10px;">商品评论</h3>
      <div class="order chakan1">
        <div class="products-lists">
          <ul class="products multi">
            <li v-for="(itx) in orderLists" :key="itx.index" @click="getItems(itx)">
              <div class="img-box">
                <img :src="itx.imgUrl">
              </div>
              <div class="info" style="flex:0.4">
                <div class="title cursor" style="max-height: 40px;line-height: 20px;overflow: hidden;">{{itx.name}}</div>
                <div class="title" style="color: #919191;">{{itx.date}}</div>
              </div>
              <div class="info" style="flex:0.6;">
                <!-- <div style="display: flex"> -->
                  <p style="color: #014492;line-height:20px">评分：{{itx.score}}</p>
                  <p class="title" style="line-height: 20px;overflow: hidden;">{{itx.content}}</p>
                <!-- </div> -->
              </div>
                <div class="info ">
                  <div class="info_span">
                    <span class="cursor" @click.stop="getItems(itx)">查看</span>
                    <span class="cursor" @click.stop="productDelete(itx.prodId)">删除</span>
                  </div>
                </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="order chakan">
        <div class="products-lists">
          <ul class="products multi">
            <li v-for="(itx) in orderLists" :key="itx.index" @click="getItems(itx)">
              <div class="li_div">
                <div class="img-box">
                  <img :src="itx.imgUrl">
                </div>
                <div class="info_first" style="overflow: auto;">
                  <div class="info" style="flex:0.4">
                    <div class="title cursor" style="max-height: 40px;line-height: 20px;overflow: hidden;">{{itx.name}}</div>
                    <div class="title" style="color: #919191;">{{itx.date}}</div>
                  </div>
                  <div class="info" style="flex:0.6;">
                    <!-- <div style="display: flex"> -->
                    <p style="color: #014492;line-height:20px">评分：{{itx.score}}</p>
                    <p class="title" style="line-height: 20px;overflow: hidden;">{{itx.content}}</p>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <div class="info">
                <div class="info_span">
                  <div class="info_span1">
                    <span class="cursor" @click.stop="getItems(itx)">查看</span>
                    <span class="cursor" @click.stop="productDelete(itx.prodId)">删除</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="page tr">
        <el-pagination
          layout="prev, pager, next"
          :total="sendTotal"
          @current-change="changeSendPage">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { reviewDelete } from '@/services/api.index'
// import { productReview, reviewDelete } from '@/services/api.index'
export default {
  data() {
    return {
      sendVisible: false,
      orderLists: [],
      sendTotal: 0,
      sendPage: 0,
      sendSize: 10,
    }
  },
  created() {
    this.productReview()
  },
  methods: {
    productReview() {
      productReview(this.sendPage, this.sendSize).then(res => {
        this.orderLists = []
        this.sendTotal = res.data.totalCount
        res.data.list.map(item => {
          this.orderLists.push({
            name: item.product.name,
            id: item.product.id,
            imgUrl: item.product.productImages[0].thumbnail,
            content: item.content,
            prodId: item.id,
            score: item.score
          })
        })
      })
    },
    // 删除
    productDelete (id) {
      this.$confirm('确定删除此评论？', '提示', {
      }).then(() => {
        reviewDelete(id).then(() => {
          this.$message.success('删除成功！')
          this.productReview()
        })
      })
    },
    getItems(item) {
      window.open(`http://8.130.53.158/product/detail/${item.id}#reviewAnchor`, '_blank');
    },
    // 翻页
    changeSendPage (value) {
      this.sendPage = value - 1
      this.productReview()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/comment_details.vue